import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const positionRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'positionRole'});

export default positionRole;